import { useState } from 'react';
import styled, { css } from 'styled-components/macro';
import { SwiperSlide } from 'swiper/react';
import { Swiper } from 'swiper/types';
import { ImageType } from '../../../hooks/api/queries/useProducts';
import { breakpoint } from '../../../styles/constants';
import { IMAGE_RATIOS } from '../../../styles/imageRatios';
import { Carousel } from '../../ui/carousel/Carousel';
import { CarouselControls } from '../../ui/carousel/CarouselControls';
import { WImage } from '../../ui/image/Image';

interface Props {
  images: ImageType[];
  setImageSelected: (index: number) => void;
  imageSelected: number;
}
export const DesktopProductCarousel = ({
  images,
  setImageSelected,
  imageSelected,
}: Props) => {
  const [swiper, setSwiper] = useState<Swiper>();

  let slidesPerView: number = 0;
  if (images.length >= 3) slidesPerView = 3.4;
  if (images.length === 2) slidesPerView = 2;
  return (
    <Wrapper slidesPerView={slidesPerView}>
      <Carousel
        setSwiper={setSwiper}
        slidesPerView={slidesPerView}
        initialSlide={0}
        loop={images.length > 3}
      >
        {images.length > 1 &&
          images.map(
            (image, index) => (
              <SwiperSlide
                key={`desktop-image-${image.id}-${index}`}
                onClick={() => {
                  setImageSelected(index);
                  if (index !== swiper?.realIndex) {
                    swiper?.slideToLoop(index);
                  }
                }}
              >
                <ImageWrapper active={index === imageSelected}>
                  <WImage image={image} background />
                </ImageWrapper>
              </SwiperSlide>
            ),
            // )
          )}
      </Carousel>
      <CarouselControls
        swiper={swiper}
        imageSelected={imageSelected}
        setImageSelected={setImageSelected}
        length={images.length}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div<{ slidesPerView: number }>`
  display: none;

  @media (min-width: ${breakpoint}) {
    --offset: 1.3125rem;
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
    width: calc(100% + 1.25rem);
    ${({ slidesPerView }) =>
      slidesPerView &&
      css`width: calc(${slidesPerView} * 150px + (${slidesPerView} - 1) * 1.25rem / ${slidesPerView} )}`};

    > :first-child {
      cursor: grab;
    }
    > :last-child {
      padding-left: var(--offset);
    }
  }
`;

const ImageWrapper = styled.div<{ active: boolean }>`
  width: calc(450px / 3);
  border-bottom: ${({ theme, active }) =>
    active ? `3px solid ${theme.colors.red}` : 'unset'};

  img {
    aspect-ratio: ${IMAGE_RATIOS.PRODUCT_PAGE};
    object-fit: cover;
  }
`;
